import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'assetUrl'
})
export class AssetUrlPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) {
      return '';
    }

    if (environment.production && !environment.isSandbox) {
      return value;
    }

    // Insert -sandbox before the extension
    return value.replace(/\.(png|jpg|jpeg|gif|svg)$/i, '-sandbox.$1');
  }
}
